module.exports = __webpack_public_path__ + "media/images/features/5/icon-case2-e416f88a5a1a8a4d35284a81164fe373.png";